import { IEnvironment } from 'interfaces-lib';
import { StorageType } from 'storage-service-lib';
import { buildVersion } from './build.version';

export const environment: Partial<IEnvironment> = {
  name: 'dev',
  featureFlagsUrl: 'https://platform-dev.kyloe.io/feature-flags/api/v1/client-init',
  featureFlagsApiKey: 'Kv5tiKDe4i8O7jFYZz5wNawc3d3hqJ8L7KlKXTRa',
  appName: 'adv2-manager-ui',
  identityStorageType: StorageType.LOCAL,
  production: false,
  version: buildVersion + '-DEV',
  kpHost: 'https://backend-dev.awesome-docs.io',
  kpWebApp: 'https://ad-ui-dev.awesome-docs.io',
  uiHost: 'https://manager-dev.awesome-docs.io',
  docMergeUrl: 'https://doc-merge-dev.awesome-docs.io',

  // API Gateway Config
  adApiGatewayUrl: 'https://api-datatoolsadmin.kyloe.plus/stephen-dev',
  adApiGatewayKey: 'PbFTLDLVTF1JateBwg0TG4KxU7hZvzJKzzykQqQh',

  enableAnalytics: false,

  // AWS RUM Config
  awsRum: {
    endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
    guestRoleArn: 'arn:aws:iam::393399738482:role/RUM-Monitor-eu-west-1-393399738482-5317273633761-Unauth',
    identityPoolId: 'eu-west-1:a3712409-6898-4485-b8ad-393eae8f69a8',
    APPLICATION_ID: 'dd82ccc0-681b-4483-a249-14cb35ae9bbb',
    APPLICATION_REGION: 'eu-west-1',
  },

  // Google Analytics Config
  googleAnalytics: 'G-JPX47WRW9S',

  // Pendo
  pendoAPIKey: 'bcd03068-7124-483f-4fc4-3def6a43c422',

  // Chrome store URL
  chromeStoreUrl: 'https://chrome.google.com/webstore/detail/kyloe-awesomedocs/olcdkpfibmnhmkkpbbpneegnkihiioip',
};
